import api from 'api'
import { PositionEntry } from 'components/CommandPalette/CommandPalette_Utils'

export const fuzzySearchPositions = async (
  search: string,
  limit = 10
): Promise<PositionEntry[]> => {
  const response = await api.get('/admin/positions/fuzzy_search', {
    params: {
      search: search.trim(),
      limit,
    },
  })

  return response.data.items.map((item) => ({
    ...item,
    historyType: 'positions',
  }))
}
